// extracted by mini-css-extract-plugin
export default {"contextMenuButtonSeparator":"ElementContextMenu__contextMenuButtonSeparator___t9FWg","tagAnswerPopupOverlay":"ElementContextMenu__tagAnswerPopupOverlay___xFMSY"};